import request from '../utils/request';

// 获取用户账户分页列表
export function getUserAccountList(params) {
  return request({
    url: '/user-accounts/list',
    method: 'get',
    params: {
      page: params.page || 1,
      size: params.pageSize || 10,
      userId: params.userId,
      accountStatus: params.accountStatus,
      minBalance: params.minBalance,
      maxBalance: params.maxBalance,
      username: params.username,
      nickname: params.nickname,
      startTime: params.startTime,
      endTime: params.endTime
    }
  });
}

// 冻结主账户
export function freezeAccount(userId) {
  return request({
    url: `/user-accounts/${userId}/freeze`,
    method: 'post'
  });
}

// 解冻主账户
export function unfreezeAccount(userId) {
  return request({
    url: `/user-accounts/${userId}/unfreeze`,
    method: 'post'
  });
}

// 获取陪逛员账户列表
export function getAccompanyShoppingProviderAccounts(params) {
  return request({
    url: '/accompany-shopping-provider-account/list',
    method: 'get',
    params: {
      page: params.page || 1,
      size: params.pageSize || 10,
      ...params
    }
  });
}

// 获取陪逛员账户详情
export function getAccompanyShoppingProviderAccountDetail(id) {
  return request({
    url: `/accompany-shopping-provider-account/${id}`,
    method: 'get'
  });
}

// 更新陪逛员服务费率
export function updateAccompanyShoppingProviderServiceFeeRate(accountId, serviceFeeRate) {
  return request({
    url: '/accompany-shopping-provider-account/service-fee-rate',
    method: 'put',
    params: {
      accountId,
      serviceFeeRate
    }
  });
}

// 更新陪逛员账户信息
export function updateAccompanyShoppingProviderAccount(accountData) {
  return request({
    url: '/accompany-shopping-provider-account/update',
    method: 'put',
    data: accountData
  });
}

// 获取商家账户列表
export function getStoreOwnerAccounts(params) {
  return request({
    url: '/store-owner-account/list',
    method: 'get',
    params: {
      page: params.page || 1,
      size: params.pageSize || 10,
      status: params.status,
      startTime: params.startTime,
      endTime: params.endTime,
      sortField: params.sortField || 'createTime',
      sortOrder: params.sortOrder || 'desc',
      ...params
    }
  });
}

// 获取商家账户详情
export function getStoreOwnerAccountDetail(id) {
  return request({
    url: `/store-owner-account/${id}`,
    method: 'get'
  });
}

// 新增商家账户
export function addStoreOwnerAccount(accountData) {
  return request({
    url: '/store-owner-account/add',
    method: 'post',
    data: accountData
  });
}

// 更新商家账户
export function updateStoreOwnerAccount(updateData) {
  return request({
    url: '/store-owner-account/update',
    method: 'post',
    data: updateData
  });
}

// 删除商家账户
export function deleteStoreOwnerAccount(id) {
  return request({
    url: `/store-owner-account/${id}`,
    method: 'delete'
  });
}

// 批量删除商家账户
export function deleteStoreOwnerAccountBatch(ids) {
  return request({
    url: '/store-owner-account/batch',
    method: 'delete',
    data: ids
  });
}

// 统计商家账户数量
export function countStoreOwnerAccountsByStatus(status) {
  return request({
    url: '/store-owner-account/count',
    method: 'get',
    params: { status }
  });
} 